import { useState } from "react";

const show = (v) => (v === null || v === undefined || v === "" ? "-" : v);

export function ExpandableRow({ rowId, testPrefix, cells, items, dark = false, rowTestId }) {
  const [open, setOpen] = useState(false);
  const btn = dark
    ? "border-slate-600 text-slate-300 hover:bg-emerald-500/10 hover:border-emerald-500/40 hover:text-emerald-400"
    : "border-slate-300 text-slate-600 hover:bg-teal-50 hover:border-teal-300 hover:text-teal-700";
  return (
    <>
      <tr className={dark ? "border-b border-slate-700/60" : "border-b border-slate-100"} data-testid={rowTestId || `${testPrefix}-row-${rowId}`}>
        <td className="px-3 py-2.5 align-middle">
          <button data-testid={`${testPrefix}-expand-${rowId}`} onClick={() => setOpen(!open)} aria-label="Toggle details"
            className={`w-6 h-6 rounded-md border transition-colors flex items-center justify-center text-sm font-bold ${btn}`}>{open ? "−" : "+"}</button>
        </td>
        {cells}
      </tr>
      {open && (
        <tr className={dark ? "bg-[#0F172A] border-b border-slate-700/60" : "bg-slate-50 border-b border-slate-100"} data-testid={`${testPrefix}-details-${rowId}`}>
          <td colSpan={cells.length + 1} className="px-4 py-3">
            <div className="sticky left-4 max-w-[calc(100vw-4rem)] lg:max-w-[calc(100vw-24rem)] xl:max-w-5xl">
            <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
              {items.map(([k, v]) => (
                <div key={k} className="min-w-0">
                  <dt className={`text-[11px] uppercase tracking-wider font-semibold ${dark ? "text-slate-500" : "text-slate-400"}`}>{k}</dt>
                  <dd className={`text-sm font-mono break-all ${dark ? "text-slate-200" : "text-slate-800"}`}>{show(v)}</dd>
                </div>
              ))}
            </dl>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

// Shared payer/claim fields used by Received Payments and Pay-In details.
export const payerItems = (s = {}) => [
  ["Payer UPI ID", s.payer_upi], ["Payer name", s.payer_name], ["UTR / Bank ref", s.utr],
  ["Merchant order ID", s.order_id], ["Merchant user ID", s.user_id], ["Customer reference", s.customer_reference],
  ["Merchant", s.merchant_code],
];
